<div class="container">
    <div class="row">
        <div class="col-xs-12">
            <p class="text-muted" *ngIf="parentFolderName">Add folder to <b>{{parentFolderName}}</b> folder.</p>
            <form #documentFolderForm="ngForm" novalidate>
                <div class="form-group col-xs-4" [ngClass]="{'has-error': (documentFolderForm.submitted && documentFolderForm.controls.parentFolder?.invalid)}">
                    <label class="control-label" for="parentFolder">
                        Move to:
                    </label>
                    <select *ngIf="context==='moveFolder'" class="form-control" name="parentFolder" id="parentFolder"
                        [(ngModel)]="folder.parentFolderId"
                        required>
                        <option *ngFor="let folder of parentFolders"
                            [value]="folder.id" [title]="folder.name">
                            {{folder.name}}
                        </option>
                    </select>
                    <select *ngIf="context==='moveDocument'" class="form-control" name="parentFolder" id="parentFolder"
                        [(ngModel)]="document.folderId"
                        required>
                        <option *ngFor="let folder of parentFolders"
                            [value]="folder.id" [title]="folder.name">
                            {{folder.name}}
                        </option>
                    </select>
                </div>

                <div class="col-xs-12 text-right">
                    <div class="clearfix">
                        <button type="button" class="btn btn-danger mr-2" (click)="cancel()" [disabled]="savingFlag">
                            <span>Cancel</span>
                        </button>
                        <button type="submit" class="btn btn-success" (click)="save()" [disabled]="savingFlag">
                            <span *ngIf="!savingFlag">Move</span>
                            <span *ngIf="savingFlag">Moving..</span>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
